import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const CardsWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      grid-template-columns: 1fr;
    }
  `}
`;

export const Card = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid ${theme.v3.colors.neutral[90]};
    background-color: ${theme.v3.colors.neutral[100]};
  `}
`;

export const CardTitle = styled.h4`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 16px;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const CardDescription = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: 14px;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[40]};
    margin: 0 0 8px 0;
    flex-grow: 1;
  `}
`;

export const ContactWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;
